export default __webpack_public_path__ + "static/media/01.9d56d377.png";